<template>
  <div class="history-search-bar">
    <el-form :model="searchForm" label-position="top">
      <el-row :gutter="20">

        <el-col :span="24" :sm="12" :md="7" :lg="7">
          <el-form-item :label="$t('UpgradeRulesManagement.type')">
            <el-select v-model="searchForm.type" filterable
                       :placeholder="$t('UpgradeRulesManagement.typePlaceholder')" :clearable="true"
                       class="custom-tree-select-width"
                       label-position="top">
              <el-option :label="$t('UpgradeRulesManagement.typeFirmware')" value="0"/>
              <el-option :label="$t('UpgradeRulesManagement.typeParameter')" value="1"/>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="24" :sm="12" :md="7" :lg="7">
          <el-form-item :label="$t('UpgradeRulesManagement.version')">
            <el-input v-model="searchForm.version" filterable
                      :placeholder="$t('UpgradeRulesManagement.versionPlaceholder')" :clearable="true"
                      class="custom-tree-select-width"/>
          </el-form-item>
        </el-col>

        <el-col :span="24" :sm="12" :md="7" :lg="7">
          <el-form-item :label="$t('UpgradeRulesManagement.enableStatus')">
            <el-select v-model="searchForm.enable" filterable
                       :placeholder="$t('UpgradeRulesManagement.enableStatusPlaceholder')" :clearable="true"
                       class="custom-tree-select-width"
                       label-position="top">
              <el-option :label="$t('UpgradeRulesManagement.enable')" value="1"/>
              <el-option :label="$t('UpgradeRulesManagement.disable')" value="0"/>
            </el-select>
          </el-form-item>
        </el-col>
        
        <el-col :span="24" :sm="12" :md="7" :lg="7">
          <el-form-item :label="$t('UpgradeRulesManagement.userAccount')">
            <el-select 
              v-model="searchForm.userId"
              style="width: 100%"
              :loading="usersLoading"
              filterable
              clearable
              remote
              :remote-method="loadUsersList"
              :placeholder="$t('UpgradeRulesManagement.userAccountPlaceholder')"
              @change="handleUserChange"
            >
              <el-option 
                v-for="user in usersList" 
                :key="user.id" 
                :label="user.email || user.name || user.id" 
                :value="user.id" 
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" :sm="12" :md="7" :lg="4">
          <el-form-item label=" ">
            <el-button class="button-background-color" @click="search">
              {{ $t('UpgradeRulesManagement.search') }}
            </el-button>
            <el-button @click="reset" class="custom-reset-button">
              {{ $t('UpgradeRulesManagement.reset') }}
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import dialogMixin from "@/mixins/dialogMixin";
import { getUsersSimple } from '@/api/api';
import { ElMessage } from 'element-plus';

export default {
  data() {
    return {
      searchForm: {
        type: '',
        version: '',
        enable: '',
        applicantEmail: '',
        userId: '', // 新增用户ID字段用于下拉选择
      },
      usersList: [], // 账号列表数据
      usersLoading: false // 账号数据加载状态
    };
  },
  mixins: [dialogMixin],
  
  mounted() {
    // 组件挂载时加载账号列表
    this.loadUsersList();
  },

  methods: {
    // 加载账号列表数据，支持搜索
    async loadUsersList(query) {
      try {
        this.usersLoading = true;
        const res = await getUsersSimple();
        
        if (res && res.code === 0 && Array.isArray(res.data)) {
          if (query) {
            // 如果有搜索词，在本地过滤数据
            this.usersList = res.data.filter(user => 
              // 在email、name或id中搜索
              (user.email && user.email.toLowerCase().includes(query.toLowerCase())) ||
              (user.name && user.name.toLowerCase().includes(query.toLowerCase())) ||
              (user.id && user.id.toString().includes(query))
            );
          } else {
            // 如果没有搜索词，显示全部数据
            this.usersList = res.data;
          }
        } else {
          ElMessage.error(this.$t('UpgradeRulesManagement.loadUsersFailed'));
          this.usersList = [];
        }
      } catch (error) {
        console.error('加载账号列表失败:', error);
        ElMessage.error(this.$t('UpgradeRulesManagement.loadUsersFailed'));
        this.usersList = [];
      } finally {
        this.usersLoading = false;
      }
    },
    
    // 处理用户选择变化
    handleUserChange(user) {
      if (user) {
        // 查找选中的用户对象，获取email
        const selectedUser = this.usersList.find(item => item.id === user);
        if (selectedUser && selectedUser.email) {
          this.searchForm.applicantEmail = selectedUser.email;
        }
      } else {
        this.searchForm.applicantEmail = '';
      }
    },
    search() {
      let searchCondition = {};

      if (this.searchForm.type !== '') {
        searchCondition["type-eq"] = this.searchForm.type;
      }

      if (this.searchForm.version) {
        searchCondition["version-like"] = this.searchForm.version;
      }

      if (this.searchForm.enable !== '') {
        searchCondition["enable-eq"] = this.searchForm.enable;
      }

      // 根据API接口要求，使用精确匹配
      if (this.searchForm.applicantEmail) {
        searchCondition["user-email-like"] = this.searchForm.applicantEmail;
      }

      // 发送搜索请求并将搜索条件传递给父组件
      this.$emit('search', searchCondition);
    },
    reset() {
      // 重置搜索条件
      this.searchForm = {
        type: '',
        version: '',
        enable: '',
        applicantEmail: '',
      };
      this.search();
    }
  },
};
</script>
<style scoped>

</style>
